import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../../App';
import { AppContext } from '../../context/AppContext';
import { DropdownItem, DropdownList, DropdownMenuItem, MenuItem, MenuWrapper } from './Menu.style';

type MenuProps = {
  togglePage?: (page: Pages) => void;
}
const Menu = (props: MenuProps) => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent | TouchEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  return (
    <MenuWrapper>
      <ul>
        <MenuItem
          className={appContext?.activePage === Pages.Start ? 'active' : ''}
          onClick={() => props.togglePage?.(Pages.Start)}
          onKeyDown={(e) => e.key === 'Enter' && props.togglePage?.(Pages.Start)}
          tabIndex={0}
        >
          <span>Start</span>
        </MenuItem>
        <MenuItem
          className={appContext?.activePage === Pages.Services ? 'active' : ''}
          onClick={() => props.togglePage?.(Pages.Services)}
          onKeyDown={(e) => e.key === 'Enter' && props.togglePage?.(Pages.Services)}
          tabIndex={0}
        >
          <span>Tjänster</span>
        </MenuItem>
        <MenuItem
          className={appContext?.activePage === Pages.Contact ? 'active' : ''}
          onClick={() => props.togglePage?.(Pages.Contact)}
          onKeyDown={(e) => e.key === 'Enter' && props.togglePage?.(Pages.Contact)}
          tabIndex={0}
        >
          <span>Kontakt</span>
        </MenuItem>
        <DropdownMenuItem
          ref={dropdownRef}
          tabIndex={0}
          onClick={() => setDropdownOpen(o => !o)}
          onKeyDown={(e) => e.key === 'Enter' && setDropdownOpen(o => !o)}
        >
          <span>Projekt</span>
          <DropdownList $open={dropdownOpen}>
            <DropdownItem onClick={(e) => { e.stopPropagation(); navigate('/projects/puttwise'); setDropdownOpen(false); }}>
              Puttwise
            </DropdownItem>
          </DropdownList>
        </DropdownMenuItem>
      </ul>
    </MenuWrapper>
  );
}

export default Menu;
